import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from 'src/components/ProtectedRoute'

// Import pages
import HomePage from 'src/pages/HomePage/HomePage'
import AdminPage from 'src/pages/AdminPage/AdminPage'
import LogPage from 'src/pages/LogPage/LogPage'
import SearchPage from 'src/pages/SearchPage/SearchPage'
import ActivityStatsPage from 'src/pages/ActivityStatsPage/ActivityStatsPage'
import NotFoundPage from 'src/pages/NotFoundPage/NotFoundPage'
import SettingsPage from './pages/SettingsPage/SettingsPage'

const AppRoutes = ({ maintenance }) => {
  if (maintenance) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <h1>Under Maintenance</h1>
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/log/:page?"
        element={
          <ProtectedRoute>
            <LogPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/search/:id?"
        element={
          <ProtectedRoute>
            <SearchPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/school/:id"
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stats"
        element={
          <ProtectedRoute>
            <ActivityStatsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default AppRoutes
